var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',_vm._g(_vm._b({staticClass:"fixed-bottom-center",attrs:{"show":_vm.error,"dismissible":_vm.dismissible,"variant":_vm.variant}},'b-alert',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.resource.firstErrorMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }